export const QUESTIONNAIRE_LINK_IDS = {
  REQUESTER: 'requester',
  PERFORMING_LAB: 'performing-lab',
  SELECTED_TESTS: 'selected-tests',
  TEST_GROUPS: 'test-groups',
} as const;

export const OBESITY_CODING = {
  system: 'http://hl7.org/fhir/sid/icd-10-cm',
  code: 'E66.9',
  display: 'Obesity, unspecified',
};
